import { supplierIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { Supplier } from "./get-suppliers";

const SupplierDetail_ = z.intersection(
  Supplier,
  z.object({ actualLeadTimeDays: z.number().nullable() }),
);

export const SupplierDetail: z.ZodType<SupplierDetail> = SupplierDetail_;
export interface SupplierDetail extends z.infer<typeof SupplierDetail_> {}

export const getSupplier = {
  name: "getSupplier" as const,
  input: z.object({ supplierId: supplierIdFormat.schema }),
  output: z.object({ supplier: SupplierDetail }),
};
